import { graphql } from '@/gql';

export const allProducts = graphql(`
  query allProducts {
    products {
      id
      ...CardProduct
    }
  }
`);

export const createProduct = graphql(`
  mutation createProduct($createProductInput: CreateProductInput!) {
    createProduct(createProductInput: $createProductInput) {
      id
    }
  }
`);

export const updateProduct = graphql(`
  mutation updateProduct($updateProductInput: UpdateProductInput!) {
    updateProduct(updatedProduct: $updateProductInput) {
      id
    }
  }
`);

export const removeProduct = graphql(`
  mutation removeProduct($id: ID!) {
    removeProduct(id: $id) {
      id
    }
  }
`);

export const getProduct = graphql(`
  query getProduct($id: ID!) {
    product(id: $id) {
      ...PreTailorProductFragment
    }
  }
`);

export const answerQuestion = graphql(`
  mutation answerQuestion($answerPretailoringInput: AnswerPretailoringInput!) {
    answerPretailoring(answerPretailoringInput: $answerPretailoringInput) {
      id
      name
      description
      lifecycleStatus
      productIdentifier
      projectIdentifier
      version
      updatedAt
      owner {
        id
        name
      }
      tailoringProcess {
        questions {
          __typename
          ...RadioQuestionFragment
          ...CheckboxQuestionFragment
        }
        buildingBlocks {
          ...BuildingBlockFragment
        }
      }
    }
  }
`);

export const tailorBuildingBlock = graphql(`
  mutation tailorBuildingBlock($tailorBuildingBlockInput: TailorBuildingBlockInput!) {
    tailorBuildingBlock(tailorBuildingBlockInput: $tailorBuildingBlockInput) {
      id
    }
  }
`);

export const tailorBuildingBlocks = graphql(`
  mutation tailorBuildingBlocks($tailorBuildingBlocksInput: [TailorBuildingBlockInput!]!) {
    tailorBuildingBlocks(tailorBuildingBlocksInput: $tailorBuildingBlocksInput) {
      id
    }
  }
`);

export const getProductGroup = graphql(`
  query getProductGroup($id: ID!) {
    productGroup(id: $id) {
      id
      name
      description
      updatedAt
      members {
        id
        name
        description
        owner {
          id
          name
        }
        group {
          id
          name
          description
          updatedAt
        }
        lifecycleStatus
        productIdentifier
        projectIdentifier
        version
        updatedAt
      }
    }
  }
`);
